(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORAGE_KEY = "shopify_email_popup_dismissed";
    var dialog = document.getElementById("email-popup");
    if (!dialog) return;

    if (localStorage.getItem(STORAGE_KEY)) return;

    setTimeout(function() {
      dialog.showModal();
    }, 5000);

    function closePopup() {
      dialog.close();
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }

    dialog.querySelectorAll("[data-close-popup]").forEach(function(el) {
      el.addEventListener("click", closePopup);
    });

    dialog.addEventListener("cancel", function() {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
